interface FleetMembershipSummary {
  id: string;
  name: string;
  role: string;
}

interface UserProfile {
  id: string;
  email: string;
  display_name: string;
  is_platform_admin: boolean;
  fleets: FleetMembershipSummary[];
}

export function isFleetAdmin(user: UserProfile, fleetId: string): boolean {
  return user.is_platform_admin || user.fleets.some((f) => f.id === fleetId && f.role === "admin");
}

export function hasAnyAdminFleet(user: UserProfile): boolean {
  return user.is_platform_admin || user.fleets.some((f) => f.role === "admin");
}
